export default {
    name: "BlogWrapper",
}